<template>
  <CRow>
    <CCol lg="12">
      <CCard>
        <CCardHeader>
          <strong>Quản lý dự án</strong>
          <div class="card-header-actions">
              <CButton type="button" shape="pill" color="info" class="mr-1" @click="createNew">
                <CIcon name="cil-plus"/>
                Thêm mới</CButton>
            </div>
        </CCardHeader>
        <CCardBody class="pt-0">
          <CDataTable
            :items="projects"
            :fields="fields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' '}"
            :itemsPerPage="100"
            column-filter
            hover
            sorter
            pagination
            clickable-rows
            @row-clicked="rowClicked"
            >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>
            <template #stt="{item, index}">
              <td>
                {{index+1}}
              </td>
            </template>

            <template #status="{item, index}">
              <td>
                <CBadge :color="statusColor(item.status)">
                  {{item.status}}
                </CBadge>
              </td>
            </template>

          </CDataTable>
        </CCardBody>
        </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      // Table column headers
      fields: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'project', label: 'Tên dự án', _classes: 'font-weight-bold'  },
        { key: 'customer', label: 'Đối tác' },
        { key: 'contract', label: 'Hợp đồng' },
        { key: 'quantity', label: 'S/L', _style:'width:3rem;' },
        // { key: 'invoice', label: 'Hóa đơn' },
        // { key: 'desc', label: 'Mô tả' },
        { key: 'status', label: 'Trạng thái' },
        // { key: 'who', label: 'Quản lý' },
        { key: 'start', label: 'Bắt đầu' },
        { key: 'stop', label: 'Kết thúc' },
        { key: 'priority', label: 'Ư/T', _style:'width:2rem;'  },
        // { key: 'edit', label: 'Thao tác' },
      ],
      // Data for projects
      projects: []
    };
  },
  created() {
    this.getProjects()
  },
  methods: {
    getProjects() {
      this.$request('/api/project').then(res=>{
        // console.log(res.data)
        this.projects=res.data.projects
      })
    },
    rowClicked(item, index) {
      // console.log(item)
      this.editProject(item.id)
    },
    createNew(){
      this.editProject()
    },
    editProject(id) {
      // console.log('request edit project', id)
      this.$router.push({
        path: '/project/mod',
        query: {
          id: id
        }
      });
    },
    statusColor(status) {
      switch (status) {
        case "Đang thực hiện":
          return "success";
        case "Sắp quá hạn":
          return "warning";
        case "Quá hạn":
          return "danger";
        case "Hoàn thành":
          return "primary";
        default:
          return "secondary";
      }
    },
  }
};
</script>
